import { render, staticRenderFns } from "./PlantFieldDefinitionTable.vue?vue&type=template&id=2e8cb0cc&"
import script from "./PlantFieldDefinitionTable.vue?vue&type=script&lang=ts&"
export * from "./PlantFieldDefinitionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports